"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInstallationValidator = void 0;
class IInstallationValidator {
    constructor(eventStream) {
        this.eventStream = eventStream;
    }
}
exports.IInstallationValidator = IInstallationValidator;
//# sourceMappingURL=IInstallationValidator.js.map